(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-hover-media"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pbHoverVideo) return;
    window.__pbHoverVideo = 1;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    function rootOf(el) {
      var a = el && el.closest ? el.closest('a') : null;
      return a && a.querySelector('[data-pb-hover-video], .pb-hov') ? a : null;
    }
    function enter(a) {
      var m = a.querySelector('[data-pb-hover-video]');
      if (!m || !fine.matches || still.matches) return;
      if (a.classList.contains('pb-hov-off') || a.classList.contains('is-picked')) return;
      var v = m.__pbv;
      if (!v) {
        v = document.createElement('video');
        v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
        v.preload = 'auto';
        v.className = m.getAttribute('data-class') || '';
        v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;background:#fff;opacity:0;transition:opacity .25s ease;pointer-events:none';
        v.addEventListener('playing', function () { if (v.__pbOn) v.style.opacity = '1'; });
        v.src = m.getAttribute('data-pb-hover-video');
        m.parentNode.insertBefore(v, m);
        m.__pbv = v;
      }
      v.__pbOn = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function leave(a) {
      a.classList.remove('pb-hov-off');
      var m = a.querySelector('[data-pb-hover-video]');
      var v = m && m.__pbv;
      if (!v) return;
      v.__pbOn = false;
      v.pause();
      v.style.opacity = '0';
      try { v.currentTime = 0; } catch (e) {}
    }
    document.addEventListener('mouseover', function (e) {
      var a = rootOf(e.target);
      if (a && !(e.relatedTarget && a.contains(e.relatedTarget))) enter(a);
    });
    document.addEventListener('mouseout', function (e) {
      var a = rootOf(e.target);
      if (a && !(e.relatedTarget && a.contains(e.relatedTarget))) leave(a);
    });
    /* stepping the card's own photo arrows hands the frame back to the slider until the pointer leaves */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.splide__arrow') : null;
      var a = b && rootOf(b);
      if (!a || !a.querySelector('.pb-hov')) return;
      a.classList.add('pb-hov-off');
      var m = a.querySelector('[data-pb-hover-video]');
      if (m && m.__pbv) { m.__pbv.__pbOn = false; m.__pbv.pause(); m.__pbv.style.opacity = '0'; }
    }, true);
    /* a card that stands its hover photo down (picked swatch, stepped photos: .is-picked) stops the video too */
    document.addEventListener('click', function (e) {
      var a = rootOf(e.target);
      var m = a && a.querySelector('[data-pb-hover-video]');
      if (!m) return;
      setTimeout(function () {
        var v = m.__pbv;
        if (v && (a.classList.contains('is-picked') || a.classList.contains('pb-hov-off'))) {
          v.__pbOn = false; v.pause(); v.style.opacity = '0';
        }
      }, 60);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
